<template>
  <v-row class="mt-2">
    <div class="d-flex flex-grow-1 pt-3 px-3">
      <px-search-text label="Busque por um fornecedor"
                      class="rounded-tag-small"
                      v-model="searchText"
                      :on-search="onChangeSearchText"/>
    </div>
    <div class="d-flex my-3 mr-3">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" link target="_blank" :to="toPath">
            <v-icon color="primary">mdi-grid</v-icon>
          </v-btn>
        </template>
        <span>Ver quadro comparativo</span>
      </v-tooltip>
      <px-select-menu prepend-icon="mdi-sort-variant"
                      v-model="selectedSort"
                      :options="sortOptions"
                      @change="onChangeSort"/>
      <px-select-menu prepend-icon="mdi-format-list-bulleted"
                      v-model="selectedView"
                      :options="viewOptions"
                      @change="onChangeView"/>
    </div>
  </v-row>
</template>

<script>
export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
      searchText: null,
      selectedSort: null,
      sortOptions: [
        {
          description: 'Menor preço',
          value: 'total',
        },
        {
          description: 'Menor custo de transporte',
          value: 'totalTransporte',
        },
      ],
      viewOptions: [
        {
          description: 'Por fornecedor',
          value: 'FORNECEDOR',
        },
        {
          description: 'Por produto',
          value: 'PRODUTO',
        },
      ],
    };
  },
  computed: {
    toPath() {
      return `/cotacao/respostas/matriz?q=${this.cotacao.id}`;
    },
    selectedView: {
      get() {
        return this.$store.getters['cotacaoFiltro/viewMode'](this.$route.params.id);
      },
      set(viewMode) {
        this.$store.dispatch('cotacaoFiltro/viewMode', { id: this.$route.params.id, viewMode });
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.$emit('change-search-text', this.searchText);
    },
    onChangeSort() {
      this.$emit('change-sort', this.selectedSort);
    },
    onChangeView() {
      this.$emit('change-view', this.selectedView);
    },
  },
  created() {
    [this.selectedSort] = this.sortOptions;

    if (!this.selectedView) {
      [this.selectedView] = this.viewOptions;
    }

    this.$emit('change-sort', this.selectedSort);
    this.$emit('change-view', this.selectedView);
  },
};
</script>
